import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteRegistration } from "../openapi/api-client.ts";

export const useDeleteRegistration = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (registrationId: string) => {
      return deleteRegistration(registrationId);
    },
    onSettled: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ["registrations"] }),
        queryClient.invalidateQueries({ queryKey: ["events"] }),
      ]);
    },
  });
};
